import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SERVER_API_URL} from 'app/app.constants';

export type UserDeviceRegistrationPayload = {
    platformType: 'WEB';
    platformOs: 'WEB';
    notificationProviderType: 'WEB_FCM';
    notificationToken: string;
    appVersion?: string;
};

@Injectable({
    providedIn: 'root'
})
export class UserDeviceService {
    constructor(private http: HttpClient) {}

    registerUserDevice(payload: UserDeviceRegistrationPayload): Promise<void> {
        return this.http.post<void>(`${SERVER_API_URL}api/user-devices`, payload).toPromise();
    }
}
